import { Action } from 'modules/types/common';
import { PreRegHeaders } from 'store/preRegistration/types';

export const VERIFY_IMAGE = 'VERIFY_IMAGE';

export const verifyImage = (fileName: string, base64: string, headers: PreRegHeaders): Action => ({
  type: VERIFY_IMAGE,
  payload: {
    client: 'scanning',
    request: {
      method: 'post',
      url: 'verify/image',
      headers: {
        ...headers,
        maxContentLength: Infinity,
        maxRedirects: Infinity
      },
      data: {
        fileName,
        data: base64
      }
    }
  }
});
